import { regex } from "./common";

export default regex('password', /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#$%"&!*+='?^_\-~|`\/\\])[A-Za-z\d@#$%"&!*+='?^_\-~|`\/\\]{10,}$/);